module.exports = __webpack_public_path__ + "img/20200717_172047.5445bc56.jpg";